export class TaskAccumulationMembership {
	public hasTaskVariant;
	
	constructor(obj) {
		this.hasTaskVariant = obj.hasTaskVariant;
	}
} 
